"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOptionStaticClassName = exports.SelectOption = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./SelectOption.css");
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _select = require("@cbhq/cds-common/tokens/select");
var _Cell = require("../cells/Cell");
var _CellAccessory = require("../cells/CellAccessory");
var _VStack = require("../layout/VStack");
var _focus = require("../styles/focus");
var _visibility = require("../styles/visibility");
var _system = require("../system");
var _tokens = require("../tokens");
var _typography = require("../typography");
var _linaria = require("../utils/linaria");
var _selectContext = require("./selectContext");
const _excluded = ["title", "description", "multiline", "compact", "value", "disableCloseOnOptionChange", "onPress", "onKeyPress", "tabIndex", "accessibilityLabel", "testID", "disabled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const selectOptionStaticClassName = 'cds-select-option';
exports.selectOptionStaticClassName = selectOptionStaticClassName;
const pressableStyles = "cds-pressableStyles-p1tntcpb";
const selectOptionMinHeight = {
  normal: 48,
  dense: 44
};
const selectOptionMaxHeight = {
  normal: 64,
  dense: 56
};
const selectOptionCompactMinHeight = {
  normal: 40,
  dense: 40
};
const selectOptionCompactMaxHeight = {
  normal: 56,
  dense: 48
};
const SelectOption = /*#__PURE__*/(0, _react.memo)(_ref => {
  let title = _ref.title,
    description = _ref.description,
    multiline = _ref.multiline,
    compact = _ref.compact,
    value = _ref.value,
    disableCloseOnOptionChange = _ref.disableCloseOnOptionChange,
    onPress = _ref.onPress,
    onKeyPress = _ref.onKeyPress,
    tabIndex = _ref.tabIndex,
    accessibilityLabel = _ref.accessibilityLabel,
    testID = _ref.testID,
    disabled = _ref.disabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const selectOptionRef = (0, _react.useRef)(null);
  const minHeight = (0, _useScaleConditional.useScaleConditional)(compact ? selectOptionCompactMinHeight : selectOptionMinHeight);
  const maxHeight = (0, _useScaleConditional.useScaleConditional)(compact ? selectOptionCompactMaxHeight : selectOptionMaxHeight);
  const _useSelectContext = (0, _selectContext.useSelectContext)(),
    onChange = _useSelectContext.onChange,
    selectedValue = _useSelectContext.value,
    handleCloseMenu = _useSelectContext.handleCloseMenu;
  const selected = selectedValue === value;
  (0, _react.useEffect)(() => {
    if (selected) {
      var _selectOptionRef$curr;
      (_selectOptionRef$curr = selectOptionRef.current) === null || _selectOptionRef$curr === void 0 ? void 0 : _selectOptionRef$curr.focus();
    }
  }, [selected]);
  const handleChange = (0, _react.useCallback)(() => {
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
    // You can disable close on option change from either an individual SelectOption or globally through the Select or Dropdown components
    if (!disableCloseOnOptionChange) {
      handleCloseMenu === null || handleCloseMenu === void 0 ? void 0 : handleCloseMenu();
    }
  }, [onChange, value, disableCloseOnOptionChange, handleCloseMenu]);
  const handlePress = (0, _react.useCallback)(event => {
    handleChange();
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
  }, [onPress, handleChange]);
  const handleKeyPress = (0, _react.useCallback)(event => {
    handleChange();
    onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(event);
  }, [onKeyPress, handleChange]);
  return /*#__PURE__*/_react.default.createElement(_system.Pressable, {
    ref: selectOptionRef,
    noScaleOnPress: true,
    accessibilityLabel: accessibilityLabel,
    background: "background",
    className: (0, _linaria.cx)(selectOptionStaticClassName, _focus.insetFocusRing, pressableStyles),
    disabled: disabled,
    onKeyPress: handleKeyPress,
    onPress: handlePress,
    role: "menuitem",
    tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : -1 // default to -1 since this is a grouped control and the parent control will have tabIndex 0
    ,
    testID: testID
  }, /*#__PURE__*/_react.default.createElement(_Cell.Cell, _extends({}, _select.selectCellSpacingConfig, {
    accessory: /*#__PURE__*/_react.default.createElement(_CellAccessory.CellAccessory, {
      className: selected ? _visibility.visibility.visible : _visibility.visibility.hidden,
      type: "selected"
    }),
    borderRadius: "roundedNone",
    maxHeight: multiline ? undefined : maxHeight,
    minHeight: minHeight,
    selected: selected
  }, props), /*#__PURE__*/_react.default.createElement(_VStack.VStack, null, !!title && /*#__PURE__*/_react.default.createElement(_typography.TextHeadline, {
    as: "div",
    overflow: "truncate"
  }, title), !!description && /*#__PURE__*/_react.default.createElement(_typography.TextBody, {
    as: "div",
    className: multiline ? _Cell.overflowClassName : undefined,
    color: "foregroundMuted",
    overflow: multiline ? undefined : 'truncate'
  }, description))));
});
exports.SelectOption = SelectOption;